import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Equipa from "./pages/Equipa";
import EquipaDetail from "./pages/EquipaDetail";
import Ultimate from "./pages/Ultimate";
import Contactos from "./pages/Contactos";
import Aulas from "./pages/Aulas";
import PersonalTraining from "./pages/PersonalTraining";
import InscricaoAulas from "./pages/InscricaoAulas";
import MarcarAvaliacao from "./pages/MarcarAvaliacao";
import RegulamentoInterno from "./pages/RegulamentoInterno";
import TermosCondicoes from "./pages/TermosCondicoes";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade";
import ScrollToTop from "./components/ScrollToTop";
import CookieConsent from "./components/CookieConsent";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ultimate" element={<Ultimate />} />
          <Route path="/equipa" element={<Equipa />} />
          <Route path="/equipa/:id" element={<EquipaDetail />} />
          <Route path="/contactos" element={<Contactos />} />
          <Route path="/aulas" element={<Aulas />} />
          <Route path="/personal-training" element={<PersonalTraining />} />
          <Route path="/inscricao-aulas" element={<InscricaoAulas />} />
          <Route path="/marcar-avaliacao" element={<MarcarAvaliacao />} />
          <Route path="/regulamento-interno" element={<RegulamentoInterno />} />
          <Route path="/termos-e-condicoes" element={<TermosCondicoes />} />
          <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
          {/* Slugs curtos individuais para professores */}
          <Route path="/ruimarques" element={<EquipaDetail />} />
          <Route path="/manuelgonzalez" element={<EquipaDetail />} />
          <Route path="/dianasantos" element={<EquipaDetail />} />
          <Route path="/professor/:slug" element={<EquipaDetail />} />
          {/* Legacy routes redirect */}
          <Route path="/professores" element={<Equipa />} />
          <Route path="/professor/:id" element={<EquipaDetail />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
